import { ListItemIcon, ListItemText } from "@mui/material";
import * as React from "react";
import { NewMessageIcon } from "../../framework/Icon/NewMessageIcon";
import * as Styled from "./NavigationMenu.styles";

interface IHeaderItemProp {
    active: boolean;
    classes?: string;
    iconClasses?: string;
    icon?: React.ReactNode;
    disabled?: boolean;
    eventsExist?: boolean;
    text: string;
    onClick: () => void;
}

export const HeaderItem = (props: IHeaderItemProp) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (props.disabled) return;
        props.onClick();
    };

    return (
        <Styled.MenuItem disabled={props.disabled} selected={props.active} className={"appMenuItem" + (props.classes ? " " + props.classes : "") + (props.active ? " active" : "") + (props.disabled ? " disabled" : "")} onClick={(e) => handleClick(e)}>
            <ListItemIcon sx={{ color: props.active ? "primary.main" : "text.secondary", fontSize: ".5rem" }}>{props.icon}</ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: "body2", color: props.active ? "text.primary" : "text.secondary" }}>{props.text}</ListItemText>
            {!!props.eventsExist &&
                <NewMessageIcon />
            }
        </Styled.MenuItem>
    );
};